import { render, staticRenderFns } from "./UserSavedSearch.vue?vue&type=template&id=686f30df&scoped=true"
import script from "./UserSavedSearch.vue?vue&type=script&lang=js"
export * from "./UserSavedSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f30df",
  null
  
)

export default component.exports